import { Directive, forwardRef, ContentChildren, QueryList, AfterContentInit, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NimbusButtonGroupElementDirective } from '@nimbus-library/features/shared/directives/functional/nimbus-button-group-element.directive';

export const NIMBUS_BUTTON_GROUP_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  /* eslint-disable @typescript-eslint/no-use-before-define */
  useExisting: forwardRef(() => NimbusButtonGroupDirective),
  multi: true,
};

@Directive({
  selector: '[nimbusButtonGroup]',
  providers: [NIMBUS_BUTTON_GROUP_ACCESSOR],
  standalone: false,
})
export class NimbusButtonGroupDirective implements ControlValueAccessor, AfterContentInit, OnDestroy {
  private subscription$: Subscription;

  protected value: any;
  protected disabled = false;

  protected onValueChanged: (val: any) => void;
  protected onTouched: () => void;

  @ContentChildren(NimbusButtonGroupElementDirective) public elements: QueryList<NimbusButtonGroupElementDirective>;

  public constructor() {
    this.subscription$ = new Subscription();
  }

  public ngAfterContentInit(): void {
    this.setChildrenDisableStates(this.disabled);
    this.setChildrenActiveStates();
    this.elements.forEach((item) => this.subscription$.add(item.clickEvent.subscribe((val) => this.writeValue(val))));
  }

  public ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public writeValue(obj: any): void {
    if (this.value !== obj) {
      this.value = obj;
      if (this.onValueChanged) {
        this.onValueChanged(this.value);
      }
      if (this.onTouched) {
        this.onTouched();
      }
      this.setChildrenActiveStates();
    }
  }
  public registerOnChange(fn: any): void {
    this.onValueChanged = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.setChildrenDisableStates(this.disabled);
  }

  private setChildrenDisableStates(isDisabled: boolean) {
    if (this.elements) {
      this.elements.forEach((item) => {
        item.setDisabledState(isDisabled);
      });
    }
  }

  private setChildrenActiveStates() {
    if (this.elements && this.value) {
      this.elements.forEach((item) => item.setActiveState(item.value === this.value));
    }
  }
}
